import { Inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ASSETS_PATH } from '@anecdotes/design-system/injection-tokens';
import { firstValueFrom } from 'rxjs';

enum StorageKey {
  SuccessAnimation,
}

@Injectable()
export class AssetsService {
  private httpClient: HttpClient;
  private assetsStorage: { [key: string]: object } = {};

  constructor(httpBackend: HttpBackend, @Inject(ASSETS_PATH) private assetsPath: string) {
    this.httpClient = new HttpClient(httpBackend);
  }

  async getSuccessAnimation(): Promise<object> {
    if (!this.assetsStorage[StorageKey.SuccessAnimation]) {
      this.assetsStorage[StorageKey.SuccessAnimation] = await firstValueFrom(this.httpClient.get(`${this.assetsPath}/animations/success.json`));

      return this.assetsStorage[StorageKey.SuccessAnimation];
    }

    return this.assetsStorage[StorageKey.SuccessAnimation];
  }
}
